<template>
  <div id="type-ring-chart" :style="size" style="display: flex;align-items:center;flex-direction: column">
    <e-charts :size="size" :options="options" />
  </div>
</template>

<script>
import ECharts from '@/views/dataDisplay/components/ECharts'

export default {
  components: {
    ECharts,
  },
  props: {
    typeStats: {
      type: Array,
      default: () => []
    }
  },
  data: function () {
    return {
      size: {
        width: '100%',
        height: '400px',
      },
    }
  },
  computed: {
    options() {
      const chartData = this.typeStats.map(item => ({
        name: item.checkType || '未知类型',
        value: item.completedCount || 0
      }))
      
      return {
        color: [
          '#1089e7',
          '#f57474',
          '#56d0e3',
          '#f8b448',
          '#8b78f6',
          '#E75FC3',
          '#FF0099',
          '#8D7FEC',
          '#F87BE2',
          '#F2719A',
        ],
        title: {
          text: '检查类型统计',
          left: 'center',
          top: '10px',
          textStyle: {
            color: '#333',
            fontSize: 16,
          },
        },
        tooltip: {
          trigger: 'item',
          formatter: (params) => {
            return `${params.name}<br/>已完成: ${params.value}项<br/>占比: ${params.percent}%`
          },
        },
        legend: {
          top: '40px',
          left: 'center',
          textStyle: {
            color: '#333',
          },
        },
        series: [
          {
            type: 'pie',
            radius: ['30%', '67%'], // 环形图
            center: ['50%', '60%'],
            avoidLabelOverlap: true,
            itemStyle: {
              borderRadius: 10,
            },
            label: {
              show: true,
              formatter: '{b}: {c}项\n({d}%)'
            },
            labelLine: {
              show: true,
              length: 10,
              length2: 15,
            },
            data: chartData,
          },
        ],
      }
    }
  }
}
</script>

<style scoped>
</style>

